import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { TextAreaWrapper, TextArea as StyledTextArea } from "./styles"
import { P } from "../../typography"

const TextArea = ({ value, handleInputChange, expanding, characterLimit, ...rest }) => {
  useEffect(() => {
    calculateCharactersRemaining(value?.length)
  }, [value])

  const onChange = (event) => {
    const { name, value } = event.target
    calculateCharactersRemaining(value.length)
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  const showCharacterLimit = () => {
    if (isNaN(parseInt(characterLimit))) return false
    if (parseInt(characterLimit) < 1) return false
    return true
  }

  const [charactersRemaining, setCharactersRemaining] = useState(characterLimit - value?.length)
  const calculateCharactersRemaining = (characterCount) => setCharactersRemaining(characterLimit - characterCount)

  return (
    <TextAreaWrapper data-replicated-value={expanding ? value : ""}>
      <StyledTextArea value={value} onChange={onChange} maxLength={characterLimit} {...rest} />
      {showCharacterLimit() && !!value && (
        <P align="right" size="small" marginless>{`${charactersRemaining} characters remaining`}</P>
      )}
    </TextAreaWrapper>
  )
}

TextArea.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  value: PropTypes.string,
  expanding: PropTypes.bool,
  rows: PropTypes.number,
  invalid: PropTypes.bool,
  characterLimit: PropTypes.number
}

TextArea.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  value: "",
  expanding: true,
  rows: 4,
  invalid: false,
  characterLimit: undefined
}

export default TextArea
